module.exports = __webpack_public_path__ + "img/resource-icon.3ea4b7d7.png";